export default "__VITE_ASSET__09dc1b5d__"